import React from 'react';
import PropTypes from 'prop-types';

const InlineMessageBlock = (props) => {
    const {
        type = 'error',
        title = '',
        message = 'Something went wrong',
        subMessage,
        actionLabel = 'TRY AGAIN',
        actionCallback
    } = props;

    let className = 'mt-2 rounded-b shadow-md '
    if(type === 'error') {
        className += ' bg-red-100 border-t-4 border-red-500 text-red-700'
    }

    return (
        <div className={className} role="alert">
            <div className="flex px-4 py-3">
                <div className="py-1"><svg className="fill-current h-6 w-6 text-red-700 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
                <div>
                    <p className='font-bold'>{title}</p>
                    <p className="text-sm">{message}</p>
                    {
                        subMessage ? <p className="text-xs">{subMessage}</p> : null
                    }
                </div>
            </div>
            {
                actionCallback ? (
                    <div 
                        className='border-t p-2 border-red-200 font-bold text-center cursor-pointer'
                        onClick={actionCallback}    
                    >
                        {actionLabel}
                    </div>
                ) : null
            }
        </div>
    )
}

InlineMessageBlock.propTypes = {
    type: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    subMessage : PropTypes.string,
    actionLabel: PropTypes.string,
    actionCallback : PropTypes.func
};

export default InlineMessageBlock;
